import { type IPagination, PAGINATION_DOTS, paginationRangeHandler } from 'BreetHelpers';
import { useMemo } from 'react';

export const usePagination = ({ totalDocItems = 1, pageLimit, siblingCount = 1, currentPage }: IPagination) => {
	const paginationRange = useMemo(() => {
		const totalPageCount = Math.ceil(totalDocItems / pageLimit);

		const totalPageNumbers = siblingCount + 5;

		if (totalPageNumbers >= totalPageCount) {
			return paginationRangeHandler(1, totalPageCount);
		}

		const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
		const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);

		const shouldShowLeftDots = leftSiblingIndex > 2;
		const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

		const firstPageIndex = 1;
		const lastPageIndex = totalPageCount;

		if (!shouldShowLeftDots && shouldShowRightDots) {
			const leftItemCount = 3 + 2 * siblingCount;
			const leftRange = paginationRangeHandler(1, leftItemCount);

			return [...leftRange, PAGINATION_DOTS, totalPageCount];
		}
		if (shouldShowLeftDots && !shouldShowRightDots) {
			const rightItemCount = 3 + 2 * siblingCount;
			const rightRange = paginationRangeHandler(totalPageCount - rightItemCount + 1, totalPageCount);
			return [firstPageIndex, PAGINATION_DOTS, ...rightRange];
		}

		const middleRange = paginationRangeHandler(leftSiblingIndex, rightSiblingIndex);
		return [firstPageIndex, PAGINATION_DOTS, ...middleRange, PAGINATION_DOTS, lastPageIndex];
	}, [totalDocItems, pageLimit, siblingCount, currentPage]);

	return paginationRange;
};
